/**
* @file 资源管理-司机资源备份
* */
<template>
  <div id="driverBackup">
    <custom-table ref="customTable" has-organization="true" maxHeight="520" :customOptions="customOptions"
      :columns="columns" excel-type="BackupsDriver">
      <div slot="search-bottom" style="margin-top:10px;color:#999">说明：司机数据被删除后，将在这里产生一条备份记录</div>
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'created'">{{ row.created | filterTime }}</template>
        <template v-else-if="item.prop === 'lastLoginTime'">{{ row.lastLoginTime | filterTime }}</template>
        <template v-else-if="item.prop === 'updated'">{{ row.updated | filterTime }}</template>
        <template v-else-if="item.prop === 'operation'">
          <el-button type="primary" @click="compileClick(row)">查看</el-button>
        </template>
        <div v-else-if="item.prop === 'name'" class="avatar-name">
          <img class="avatar-img" v-if="row.headPortrait" :src="mixinQiniuImg(row.headPortrait)" />
          <span @dblclick="$utils.dblclickCopy">{{ row.name }}</span>
        </div>
        <template v-else>
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] : "-" }}</span>
        </template>
      </template>
    </custom-table>

    <el-drawer :visible.sync="detailShow" :close-on-click-modal="false">
      <driverFormBackup :id="detailId" />
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: "driverBackup",
  components: {
    driverFormBackup: () => import("./driverFormBackup.vue"),
  },
  data() {
    return {
      // 配置项
      customOptions: {

        // 请求的列表url
        url: "/api/v1/manage/backups/driver",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {
            type: "input",
            field: "name",
            name: "司机名称",
            value: "",
          },
          {
            type: "input",
            field: "phone",
            name: "手机号码",
            value: "",
          },
          {
            type: "input",
            field: "idCard",
            name: "身份证号",
            value: "",
          },
        ],
      },
      columns: [
        { prop: "name", label: "司机名称" },
        { prop: "phone", label: "手机号码" },
        { prop: "idCard", label: "身份证号" },
        { prop: "openingBank", label: "开户行" },
        { prop: "bankCardNo", label: "银行卡号" },
        { prop: "created", label: "注册时间" },
        { prop: "lastLoginTime", label: "最后登录时间" },
        { prop: "updated", label: "删除时间" },
        { prop: "operation", label: "操作" },
      ],
      detailShow: false,
      detailId: null
    };
  },
  methods: {
    /* 查看*/
    compileClick(row) {
      this.detailId = row.id;
      this.detailShow = true;
    },
  },
};
</script>

<style lang="less">
#driverBackup {
  height: 100%;

  .el-drawer {
    padding: 2%;
    width: 1250px !important;
    overflow: scroll;
  }

  .avatar-name {
    display: flex;
    align-items: center;

    .avatar-img {
      width: 32px;
      height: 32px;
      background-color: #ccc;
      border-radius: 50%;
      margin-right: 6px;
    }
  }
}
</style>
